import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Switch,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/system";
import React, { useState } from "react";
import { useFormAccordo } from "../ContextAccordo";
import { NumericFormat } from "react-number-format";

const materialUITextFieldProps = {
  label: "Prezzo",
  id: "prezzo",
  required: true,
};

const GaranzieModale = ({ open, setOpen }) => {
  const theme = useTheme();

  const { formState, dispatch } = useFormAccordo();
  const [garanzia, setGaranzia] = useState({
    nome: "",
    prezzo: "",
    obbligatorio: 0,
    visibile: 0,
    frazionamento: 0,
    incluso: 0,
  });

  const handleChangeSwitch = (event, el) => {
    setGaranzia({
      ...garanzia,
      [el]: event.target.checked ? 1 : 0,
    });
  };

  /* console.log(garanzia); */

  const handleClose = () => {
    setGaranzia({
      nome: "",
      prezzo: "",
      obbligatorio: 0,
      visibile: 0,
      frazionamento: 0,
      incluso: 0,
    });
    setOpen(false);
  };

  const handleSave = () => {
    // Calculate the next idGaranzia
    const nextIdGaranzia =
      formState.garanzie.length > 0
        ? Math.max(...formState.garanzie.map((g) => g.idGaranzia)) + 1
        : 1;

    // Dispatch the new garanzia with the calculated idGaranzia
    dispatch({
      type: "set_new_garanzia",
      payload: {
        garanzia: {
          ...garanzia,
          idGaranzia: nextIdGaranzia, // Add the calculated idGaranzia
        },
      },
    });
    handleClose();
  };

  return (
    <>
      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "300px", // Set your width here
              backgroundColor:
                theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
            },
          },
        }}
      >
        <DialogTitle>Aggiungi Garanzia</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap="12px" mt={4}>
            <TextField
              size="small"
              margin="none"
              label="Nome"
              required
              fullWidth
              id="nome-modale"
              name="nome-modale"
              style={{ minWidth: 120 }}
              value={garanzia.nome}
              onChange={(e) =>
                setGaranzia({ ...garanzia, nome: e.target.value })
              }
            />
            <NumericFormat
              {...materialUITextFieldProps}
              customInput={TextField}
              prefix="€"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              sx={{ minWidth: 120 }}
              valueIsNumericString
              value={garanzia.prezzo}
              onValueChange={(e) =>
                setGaranzia({ ...garanzia, prezzo: e.value })
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            flexDirection="column"
            gap={8}
            mt={2}
          >
            {["Obbligatorio", "Visibile", "Frazionamento", "Incluso"].map(
              (el, i) => (
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                  gap={4}
                  key={el}
                >
                  <Typography fontWeight="bold">{el}</Typography>
                  <Switch
                    sx={{
                      "&.MuiSwitch-root .MuiSwitch-switchBase": {
                        color: "#ccc",
                      },
                      "&.MuiSwitch-root .Mui-checked": {
                        color: "#407ad6",
                      },
                    }}
                    onChange={(event) =>
                      handleChangeSwitch(event, el.toLowerCase())
                    }
                  />
                </Box>
              )
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            sx={{ marginRight: "8px" }}
          >
            Chiudi
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            sx={{ marginRight: "8px" }}
          >
            Salva
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GaranzieModale;
